import { defineStore } from 'pinia';
import { toast } from "@/utils/index.js";
import { Login } from "@/api/auth.js";
import { UserInfo } from "@/api/user.js";

const TokenKey = 'token';

export const useUserStore = defineStore('user', {
	state: () => ({
		hasLogin: uni.getStorageSync(TokenKey) ? true : false,
		token: uni.getStorageSync(TokenKey),
		userInfo: {},
		guardList: []
	}),
	getters: {
		// 借贷功能开关：后管按用户白名单开放，1=开启，0/null 均视为未开放
		isLoanOpen: (state) => state.userInfo.loanSwitch == 1,
		// 信誉分：0-100 纯展示字段，未返回时为 null（不展示）
		creditScore: (state) => {
			const score = state.userInfo.creditScore;
			return score === null || score === undefined || score === '' ? null : Number(score);
		}
	},
	actions: {
		onSetToken(token) {
			this.token = token;
			uni.setStorageSync(TokenKey, token);
		},
		onRemoveToken(){
			this.token = '';
			uni.removeStorageSync(TokenKey);
		},
		// 获取用户信息
		onGetUserInfo(){
			return UserInfo().then((res) => {
				this.hasLogin = true;
				this.userInfo = { ...this.userInfo, ...res.result };
				return res;
			});
		},
		//登录
		onLogin(params){
			return Login(params).then(res =>{
				this.onSetToken(res.result);
				return res;
			})
		},
		//退出登录
		onLoginOut(){
			return LoginOut().then(res => {
				this.onResetStatus();
			})
		},
		onResetStatus(){
			this.hasLogin = false;
			this.userInfo = {};
			this.onRemoveToken();
		}
	}
});
